import capImage from "#/assets/store/mezo-cap.png"
import capFullImage from "#/assets/store/mezo-cap-full.png"
import hoodieImage from "#/assets/store/mezo-hoodie.png"
import hoodieFullImage from "#/assets/store/mezo-hoodie-full.png"
import tshirtImage from "#/assets/store/mezo-t-shirt.png"
import tshirtFullImage from "#/assets/store/mezo-t-shirt-full.png"

export type StoreItem = {
  id: string
  name: string
  image: string
  fullImage: string
  price: number
  description: string
}

const STORE_ITEM_HAT: StoreItem = {
  id: "dac103b5-e0eb-49fa-806e-34089acd63fe",
  name: "Mezo Cap",
  price: 300,
  image: capImage,
  fullImage: capFullImage,
  description:
    "Top off your look with a dash of 'stache—this cozy beanie keeps you smiling no matter the season!",
}

const STORE_ITEM_TSHIRT: StoreItem = {
  id: "36919d71-344b-4887-86b3-5ce903968a87",
  name: "Everything on Bitcoin T-shirt",
  price: 700,
  image: tshirtImage,
  fullImage: tshirtFullImage,
  description:
    "Strut in our tee and show the world you're tuned into the future—bold, buzzy, everything Bitcoin.",
}

const STORE_ITEM_HOODIE: StoreItem = {
  id: "7ba53af4-24ee-4261-a590-6dd90101b148",
  name: "Owners Club Hoodie",
  price: 1300,
  image: hoodieImage,
  fullImage: hoodieFullImage,
  description:
    "Slip into our casual 'Owners Club' hoodie and show others you're on to something. Touch grass in style.",
}

export const STORE_ITEMS: StoreItem[] = [
  STORE_ITEM_TSHIRT,
  STORE_ITEM_HAT,
  STORE_ITEM_HOODIE,
]
